module.exports = __webpack_public_path__ + "static/media/DC-Velocity.85a01ad0.png";